export default __webpack_public_path__ + "static/media/magnet-demo.4cf7f3ca.gif";